if (!customElements.get('product-quantity')) {
  class ProductQuantity extends HTMLElement {
    constructor() {
      super();

      this.incrementRef = this.increment.bind(this);
      this.decrementRef = this.decrement.bind(this);
      this.handleVariantChangeRefChange = this.handleVariantChange.bind(this);
    }

    static get observedAttributes() {
      return ["data-max"];
    }

    attributeChangedCallback(attribute, previousValue, currentValue) {
      if(attribute != "data-max" || !this.input || currentValue == null) return;

      const variantInventoryPolicy = this.getAttribute('data-variant-inventory-policy');
      let maxValue = currentValue;
      let inputValue = this.input.value;

      if (maxValue <= 0) {
        maxValue = 1;
      }

      if (variantInventoryPolicy === 'deny') {
        this.input.setAttribute('max', maxValue);
        inputValue = Math.min(inputValue, maxValue);
      } else {
        this.input.removeAttribute('max');
      }

      this.input.value = inputValue;
      this.updateButtons();
    }

    handleVariantChange(event) {
      if (event.detail.productId != this.getAttribute('data-product-id')) return;
      if (!event.detail.option) return;

      this.setAttribute('data-max', event.detail.variantInventoryQuantity);
      this.setAttribute('data-variant-inventory-policy', event.detail.variantInventoryPolicy);
    }

    updateButtons() {
      this.incrementButton.toggleAttribute('disabled', this.input.value == this.getAttribute('data-max'));
      this.decrementButton.toggleAttribute('disabled', this.input.value == 1);
    }

    increment(event) {
      event.preventDefault();
      const inventoryPolicy = this.getAttribute('data-variant-inventory-policy');
      let maxValue = this.getAttribute('data-max');
      if (maxValue <= 0) {
        maxValue = 1;
      }
      if (inventoryPolicy === 'continue') {
        this.input.value = Number(this.input.value) + 1;
      } else {
        this.input.value = Math.min(Number(this.input.value) + 1, maxValue);
      }
      this.updateButtons();
    }

    decrement(event) {
      event.preventDefault();
      this.input.value = Math.max(Number(this.input.value) - 1, 1);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.incrementButton.removeEventListener('click', this.incrementRef);
      this.decrementButton.removeEventListener('click', this.decrementRef);

      document.removeEventListener('alexa:variant-change', this.handleVariantChangeRefChange);
    }

    connectedCallback() {
      this.input = this.querySelector('input');

      this.incrementButton = this.querySelector('[data-action="1"]');
      this.decrementButton = this.querySelector('[data-action="-1"]');

      this.incrementButton.addEventListener('click', this.incrementRef);
      this.decrementButton.addEventListener('click', this.decrementRef);

      document.addEventListener('alexa:variant-change', this.handleVariantChangeRefChange);
    }
  }

  customElements.define('product-quantity', ProductQuantity);
}
